// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"e48b7a6c","28":"0f56aab6","239":"5038e6a2","434":"516906bc","676":"5ee24718","711":"6a02be31","835":"af8944f2","910":"06f67f96"}[chunkId] + ".chunk.js";
};